import { render, staticRenderFns } from "./SummaryAccountsReceivable.vue?vue&type=template&id=23ca2ed6"
import script from "./SummaryAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./SummaryAccountsReceivable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports